module.exports = __webpack_public_path__ + "static/media/card_3.40dbd573.png";